var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4881 16.334C30.4881 15.294 30.3975 14.294 30.2293 13.334H16.8223V19.014H24.4835C24.1469 20.8406 23.1375 22.3874 21.6233 23.4274V27.1206H26.2433C28.9352 24.5606 30.4881 20.8006 30.4881 16.334Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8219 30.6674C20.6654 30.6674 23.8878 29.3608 26.243 27.1208L21.623 23.4274C20.3548 24.3074 18.7372 24.8408 16.8219 24.8408C13.1207 24.8408 9.976 22.2674 8.85012 18.8008H4.11365V22.5874C6.45601 27.3742 11.2572 30.6674 16.8219 30.6674Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85116 18.7858C8.56647 17.9058 8.39823 16.9724 8.39823 15.9991C8.39823 15.0258 8.56647 14.0924 8.85116 13.2124V9.42578H4.11469C3.1441 11.3991 2.58765 13.6258 2.58765 15.9991C2.58765 18.3724 3.1441 20.5992 4.11469 22.5724L7.80293 19.6124L8.85116 18.7858Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8219 7.17398C18.9184 7.17398 20.7819 7.92066 22.2702 9.36066L26.3466 5.16066C23.8747 2.78732 20.6654 1.33398 16.8219 1.33398C11.2572 1.33398 6.45601 4.62732 4.11365 9.42732L8.85012 13.214C9.976 9.74732 13.1207 7.17398 16.8219 7.17398Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.a03f5768e27d980854b8c52b861d6ab3.svg";
export { ForwardRef as ReactComponent };